import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SCRIPTBLOCK_LEGACY_FIELD_ORDER = [
  "script_position",
  "script"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  scriptBlockDescriptor: _generatedScriptBlockDescriptor,
  scriptBlockBlocDefinition,
  scriptBlockDashboardLayout,
  scriptBlockConfig,
  scriptBlockResolveConfig,
  scriptBlockProperties,
} = doodBlockConfig(
  {
    name: "Script",
    componentType: 'ScriptBlockComponent',
    category: 'system',
    description: "Script.",
    keywords: [],
    sharedFields: {}
  },

  () => ({
    script_position: propertyValue({
      type: 'select',
      value: "body",
      options: {
        label: "pages.blocks.script.script-position.label",
        help: "pages.blocks.script.script-position.help",
        multiple: false,
        choices: [
          {
            value: "body",
            label: "pages.blocks.script.script-position.options.body",
          },
          {
            value: "head",
            label: "pages.blocks.script.script-position.options.head",
          },
        ]
      }
    }),
    script: propertyValue({
      type: 'textarea',
      value: '',
      options: {
        label: "pages.blocks.script.script.label",
        help: "pages.blocks.script.script.help",
        rows: 20,
        monospace: true
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.script.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.script.fieldset.script.label",
            fields: ["script_position", "script"],
          },
        ],
      },
    ],
  })
);

export function scriptBlockDescriptor(): IBlockDescriptor;
export function scriptBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function scriptBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedScriptBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedScriptBlockDescriptor, scriptBlockProperties, fieldOrder);
}

export {
  scriptBlockBlocDefinition,
  scriptBlockDashboardLayout,
  scriptBlockProperties,
  scriptBlockConfig,
  scriptBlockResolveConfig,
};

export type ScriptBlockConfig = typeof scriptBlockConfig;
